import { Provider } from '@angular/core';

import { ConfigService } from './config/config.service';
import { provideSignageContent } from './content/content-provider';
import { ContentRegistryService } from './content/content-registry.service';
import { DEFAULT_CONTENT_PROVIDERS } from './content/default-providers';
import { SignageRuntimeOptionsModel } from './models';
import { ScopedContentStoreService } from './persistence/scoped-content-store.service';
import { PlaybackService } from './playback/playback.service';
import { SIGNAGE_PROFILE } from './profile';
import { NetworkMonitorService } from './resilience/network-monitor.service';
import { WatchdogService } from './resilience/watchdog.service';
import { RefreshSchedulerService } from './scheduler/refresh-scheduler.service';
import { SignageRuntimeService } from './signage-runtime.service';

/** The host still owns `SignageDataSource`; everything the runtime needs beyond it is registered here. */
export function provideSignageRuntime(options: SignageRuntimeOptionsModel = {}): Provider[] {
  return [
    ConfigService, ContentRegistryService, PlaybackService, RefreshSchedulerService, NetworkMonitorService, WatchdogService,
    ScopedContentStoreService, SignageRuntimeService,
    { provide: SIGNAGE_PROFILE, useValue: options.profile ?? 'display' },
    ...provideSignageContent(...(options.contentProviders ?? DEFAULT_CONTENT_PROVIDERS))
  ];
}
